import { styled } from '@mui/material/styles';

const StyledSubscriptionSuggestion = styled('div')`
  display: flex;
  align-items: center;
  gap: 48px;
  overflow: hidden;

  @media (max-width: 905px) {
    gap: 32px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const StyledHeaderMobile = styled('div')`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    width: 100%;
  }
`;

export { StyledSubscriptionSuggestion, StyledHeaderMobile };
